// extracted by mini-css-extract-plugin
export default {"info_panel":"info_panel_info_panel__wJF4v","info_panel_title":"info_panel_info_panel_title__URczb","info_panel_description":"info_panel_info_panel_description__fzdQA"};